export default __webpack_public_path__ + "static/O0028-03a3c568e4e4449b60c1d723a3877498.png";